import { CSSProperties, FC, useMemo, ReactNode, } from "react";
// 组件
import { ProTransfer } from "../../antd";
import LeftTable from "./leftTable";
import RightTable from "./rightTable";
// 方法
import { filterOptionFieldnames } from "./util";
// 常量
import { STATUS_CREATED, STATUS_CREATED_CODE, } from "../../constants/constant";
import { TableTransferProps } from "../interface";

const titles: ReactNode[] = ['可选项', <span className="text-success">已选项</span>];
const TableTransfer: FC<TableTransferProps> = props => {
  const {
    dataSource, listHeight, listWidth, isMoveSort, selectedDataSource, rowKey, columns, searchFieldnames,
    onChange, onDragEnd,
  } = props;
  /** 根据搜索内容进行筛选 */
  const handleFilterOption = (searchValue: string, option: any) => {
    if (!searchFieldnames) return true;
    return filterOptionFieldnames(searchValue, searchFieldnames, option);
  };
  /** 穿梭器样式 */
  const listStyle: CSSProperties = useMemo(() => {
    return {
      width: listWidth,
      height: listHeight,
    };
  }, [listWidth, listHeight]);
  const targetKeys = useMemo(() => {
    return selectedDataSource?.filter(item => item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE)?.map(item => item.key);
  }, [selectedDataSource]);

  return (
    <ProTransfer
      dataSource={dataSource}
      targetKeys={targetKeys}
      listStyle={listStyle}
      showSelectAll={false}
      oneWay={true}
      titles={titles}
      showSearch={!!searchFieldnames}
      onChange={onChange}
      filterOption={handleFilterOption}
    >
      {
        ({
          direction,
          filteredItems,
          onItemSelect,
          onItemSelectAll,
          selectedKeys: listSelectedKeys,
          disabled: listDisabled,
        }) => {
          const tableWidth = listWidth ? listWidth - 12 : listWidth;
          const tableHeight = listHeight ? listHeight - (searchFieldnames ? 142 : 82) : listHeight;
          return direction === 'left' ? (
            <LeftTable
              rowKey={rowKey}
              columns={columns}
              dataSource={filteredItems}
              width={tableWidth}
              height={tableHeight}
              rowSelection={{
                getCheckboxProps: () => ({ disabled: listDisabled }),
                onChange(selectedRowKeys: any[]) {
                  onItemSelectAll(selectedRowKeys, 'replace');
                },
                selectedRowKeys: listSelectedKeys,
              }}
              onRow={({ key, disabled: itemDisabled }) => ({
                onClick: () => {
                  if (itemDisabled || listDisabled) {
                    return;
                  }
                  onItemSelect(key, !listSelectedKeys.includes(key));
                },
              })}
            />
          ) : (
            <RightTable
              columns={columns}
              dataSource={filteredItems}
              width={tableWidth}
              height={tableHeight}
              selectedDataSource={selectedDataSource}
              isMoveSort={isMoveSort}
              onDelete={(key) => {
                onChange?.([], 'left', [key]);
              }}
              onDragEnd={onDragEnd}
            />
          );
        }
      }
    </ProTransfer>
  );
};

export default TableTransfer;
